import {
    Contract,
    SingleProductConfigOptionProps,
} from '@/modules/Contract/types'
import { Path, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

interface ConfigShowProps extends SingleProductConfigOptionProps {}

const ConfigShow: React.FC<ConfigShowProps> = ({ index, name }) => {
    const formControl = useFormContext()
    const { t } = useTranslation()

    const commitment_value = useWatch({
        control: formControl.control,
        name: `${name}.[${index}].commitment_value` as Path<Contract>,
    })

    const unit = useWatch({
        control: formControl.control,
        name: `${name}.[${index}].unit` as Path<Contract>,
    })

    const nameConfig = useWatch({
        control: formControl.control,
        name: `${name}.[${index}].name` as Path<Contract>,
    })

    const title = useWatch({
        control: formControl.control,
        name: `${name}.[${index}].title` as Path<Contract>,
    })

    return (
        <div className="border-b border-gray-100 px-4 py-2 flex gap-4">
            <Typogaphy className="font-medium text-gray-600 flex-1">
                {t(title || nameConfig)}
            </Typogaphy>

            <Typogaphy className="flex-1">
                {commitment_value
                    ? `X${commitment_value} ${t(unit === 'qty' ? '' : unit)}`
                    : t(unit)}
            </Typogaphy>
        </div>
    )
}

export default ConfigShow
